import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientSharedUiThemeModule } from '@elight/client/shared/ui/theme';

import { ProgressButtonComponent } from './progress-button/progress-button.component';
import { FixedDimensionsDirective } from './fixed-dimensions.directive';
import { UnsavedDataDialogComponent } from './unsaved-data-dialog/unsaved-data-dialog.component';
import { PanelFooterComponent } from './panel-footer/panel-footer.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DataCardComponent } from './data-card/data-card.component';
import { DataRowComponent } from './data-row/data-row.component';
import { PercentInputComponent } from './percent-input/percent-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HasAccessDirective } from './has-access.directive';
import { ColumnMenuComponent } from './column-menu/column-menu.component';
import { ColumnViewComponent } from './column-view/column-view.component';
import { CamelCaseSpace } from './pipes';

@NgModule({
    imports: [
        CommonModule,
        ClientSharedUiThemeModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    declarations: [
        CamelCaseSpace,
        ProgressButtonComponent,
        FixedDimensionsDirective,
        UnsavedDataDialogComponent,
        PanelFooterComponent,
        ConfirmDialogComponent,
        DataCardComponent,
        DataRowComponent,
        PercentInputComponent,
        HasAccessDirective,
        ColumnMenuComponent,
        ColumnViewComponent,
    ],
    exports: [
        CamelCaseSpace,
        ProgressButtonComponent,
        UnsavedDataDialogComponent,
        PanelFooterComponent,
        ConfirmDialogComponent,
        DataCardComponent,
        DataRowComponent,
        PercentInputComponent,
        HasAccessDirective,
        ColumnMenuComponent,
        ColumnViewComponent,
    ],
})
export class ClientSharedUiCommonModule {}
